import { FiInstagram } from 'react-icons/fi';
import { BsTwitter } from 'react-icons/bs';
import { HiOutlineMail } from 'react-icons/hi';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import PrivacyModal from '../PrivacyModal';
import TermsModal from '../TermsModal';
const Footer = () => {
    const { t } = useTranslation();
    const [modalShow, setModalShow] = useState(false);
    const [modalShow1, setModalShow1] = useState(false);
    var today = new Date();
    var yyyy = today.getFullYear();
    return (
        <footer className="d-flex flex-column  align-items-center gap-2">
            <PrivacyModal
                title="Privacy Policy"
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
            <TermsModal
                title="Terms and Conditions"
                show={modalShow1}
                onHide={() => setModalShow1(false)}
            />
            <div
                style={{ padding: '2rem 1rem', paddingBottom: 'calc(2rem + env(safe-area-inset-bottom))' }}
                className="d-flex flex-column  align-items-center gap-4"
            >
                <ul className="d-flex align-items-center gap-3 flex-wrap justify-content-center" style={{ padding: 0, margin: 0 }}>
                    <li>
                        <p style={{cursor:'pointer', margin: 0, padding: '0.5rem', minHeight: '44px', display: 'flex', alignItems: 'center', fontSize: 'clamp(0.9rem, 2.5vw, 1rem)', touchAction: 'manipulation'}} onClick={() => setModalShow(true)}>
                            {t('privacy')}
                        </p>
                    </li>
                    <li>
                        <p style={{cursor:'pointer', margin: 0, padding: '0.5rem', minHeight: '44px', display: 'flex', alignItems: 'center', fontSize: 'clamp(0.9rem, 2.5vw, 1rem)', touchAction: 'manipulation'}} onClick={() => setModalShow1(true)}>
                            {t('terms')}
                        </p>
                    </li>
                    <li>
                        <Link to="/about" style={{ padding: '0.5rem', minHeight: '44px', display: 'flex', alignItems: 'center', fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                            {t('about')}
                        </Link>
                    </li>
                    <li>
                        <Link to="/contact" style={{ padding: '0.5rem', minHeight: '44px', display: 'flex', alignItems: 'center', fontSize: 'clamp(0.9rem, 2.5vw, 1rem)' }}>
                            {t('contact')}
                        </Link>
                    </li>
                </ul>
                <ul className="d-flex align-items-center gap-3" style={{ padding: 0, margin: 0 }}>
                    <li>
                        <a target='_blank' rel="noreferrer" href="https://www.instagram.com/kamadicecom" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '44px', minHeight: '44px', touchAction: 'manipulation' }}>
                            <FiInstagram style={{ fontSize: '1.5rem' }} />
                        </a>
                    </li>
                    <li>
                        <a target='_blank' rel="noreferrer" href="https://www.twitter.com/kamadicecom" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '44px', minHeight: '44px', touchAction: 'manipulation' }}>
                            <BsTwitter style={{ fontSize: '1.5rem' }} />
                        </a>
                    </li>
                    <li>
                        <a href="mailto:kamadice@gmail.com" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '44px', minHeight: '44px', touchAction: 'manipulation' }}>
                            <HiOutlineMail style={{ fontSize: '1.5rem' }} />
                        </a>
                    </li>
                </ul>
            </div>
            <div className="copyright">
                <p style={{ color:'black' }}>
                    {t('copyright')} © {yyyy} . {t('rights')}
                </p>
            </div>
        </footer>
    );
};
export default Footer;
